// import React from "react";

// const DiscardConfirmationModal = ({
//   isOpen,
//   onCancel,
//   onConfirm,
//   entityName = "Record",
  
// }) => {
//   if (!isOpen) return null;

//   return (
//     <>
//       <div className="drawer-overlay" />
//       <div
//         className="entity-drawer modal-popup-cls"
//         style={{
//           maxWidth: 650,
//           margin: "0 auto",
//           background: "white",
//           borderRadius: 12,
//           zIndex: 1050,
//           padding: "20px 25px",
//           position: "fixed",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
//           height: "auto",
//           right: "auto",
//           overflow: "inherit",
//           // gap: "20px"
//         }}
//       >
//         <div className=" d-flex justify-content-end align-items-center pt-0 pe-0">
//           <button
//             onClick={onCancel}
//             style={{
//               background: "none",
//               border: "none",
//               padding: 0,
//               cursor: "pointer",
//               outline: "none",
//             }}
//             onFocus={(e) => e.target.blur()} // optional: removes focus highlight instantly
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="18"
//               height="18"
//               viewBox="0 0 18 18"
//               fill="none"
//             >
//               <path
//                 d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5"
//                 stroke="black"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//           </button>
//         </div>
//         <h3
//           style={{
//             textAlign: "left",
//             color: "#212529",
//             fontSize: "20px",
//             fontWeight: "600",
//             lineHeight: "24px",
//             fontFamily: "Montserrat",
//             marginBottom: "10px",
//             paddingTop:'20px'
//           }}
//         >
//             {(entityName === 'Listing') ? 'Confirm to discard' : (entityName === 'SKU Variation and its Options' || entityName === 'Variation Option')
//               ? `Confirm to delete this ${entityName}`
//               : (entityName === 'SPU and SKU'
//                   ? 'Confirm to discard SPU & SKU'
//                   : 'Confirm to discard ' +
//                     (entityName === 'SKU Variation' || entityName === 'Generation Rule' ? 'the ' : 'this ') +
//                     (entityName === 'SKU Abbreviation'
//                       ? 'Abbreviation'
//                       : entityName === 'Category'
//                         ? 'Category Info'
//                         : (entityName || 'Record')
//                     )
//                 )
//             }

//           ?
//         </h3>
        
//         { entityName ==="SKU Variation" || entityName ==="Branch" || entityName === 'Generation Rule' || entityName == 'SKU Abbreviation' || entityName === "SPU and SKU" || entityName === 'SKU Variation and it Options' || entityName === 'Variation Option' ? (<p
//           style={{
//             marginBottom: "0",
//             textAlign: "left",
//             color: "#6C757D",
//             fontSize: "14px",
//             fontWeight: "400",
//             lineHeight: "20px",
//             fontFamily: "Montserrat",
//             paddingBottom:'20px'
//           }}
//         >
//           {(entityName === 'SKU Variation and it Options' || entityName === 'Variation Option') ? 'SKUs generated by ' + (entityName === 'Variation Option' ? 'this Variation Option' : 'these Variation Options') + ' will also be deleted at the same time. This action cannot be undone.' : 'All unsaved changes '+((entityName === "SPU and SKU") ? 'in all steps ' : '')+'will be lost.'}

//                 </p>):(<p
//           style={{
//             marginBottom: "0",
//             textAlign: "left",
//             color: "#6C757D",
//             fontSize: "14px",
//             fontWeight: "400",
//             lineHeight: "20px",
//             fontFamily: "Montserrat",
//             paddingBottom:'20px'
//           }}
//         >
//           {/* {(entityName === "SKU Variation and its Options" ? 'SKUs generated by these Variation Options will also be deleted at the same time. This action cannot be undone.' : 'This action cannot be undone ')} */}
//                {
//                 entityName === "SKU Variation and its Options"
//                   ? "SKUs generated by these Variation Options will also be deleted at the same time. This action cannot be undone."
//                   : entityName === "Bulk Pricing" || entityName === "Brand" || entityName === "Category" || entityName === "Listing"
//                   ? "All unsaved changes will be lost"
//                   : "This action cannot be undone."
//               }
//                </p>)}
//         <div className="drawer-footer" style={{ paddingTop: "10px",paddingBottom:"10px" }}>
//           <button
//             onClick={onCancel}
//             style={{
//               display: "flex",
//               height: "34px",
//               minWidth: "100px",
//               padding: "10px 0px",
//               justifyContent: "center",
//               alignItems: "center",
//               gap: "10px",
//               borderRadius: "8px",
//               border: "1px solid  var(--navbar-dropdown-active, #212529)",
//               background: "var(--Background-White, #FFF)",
//               boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.10)",
//               color: "var(--navbar-dropdown-active, #212529)",
//               fontFamily: "Montserrat",
//               fontSize: "12px",
//               fontWeight: 600,
//               fontStyle: "normal",
//               lineHeight: "normal",
//             }}
//             onMouseDown={(e) => e.stopPropagation()}
//           >

//             Cancel
//           </button>

//           <button
//             onClick={onConfirm}
//             style={{
//               display: "flex",
//               height: "34px",
//               minWidth: "100px",
//               padding: "10px 0px",
//               justifyContent: "center",
//               alignItems: "center",
//               gap: "10px",
//               borderRadius: "8px",
//               background: "var(--navbar-dropdown-active, #212529)",
//               boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.10)",
//               color: "var(--Background-White, #FFF)",
//               fontFamily: "Montserrat",
//               fontSize: "12px",
//               fontWeight: 600,
//               fontStyle: "normal",
//               lineHeight: "normal",
//             }}
//             onMouseDown={(e) => e.stopPropagation()}
//           >
//             Confirm
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default DiscardConfirmationModal;

import React from "react";

const DiscardConfirmationModal = ({
  isOpen,
  onCancel,
  onConfirm,
  entityName = "Record",
}) => {
  if (!isOpen) return null;

  const isManageOrder = entityName === "Manage Order";

  return (
    <>
      <div className="drawer-overlay" />
      <div
        className="entity-drawer modal-popup-cls"
        style={{
          maxWidth: 650,
          margin: "0 auto",
          background: "white",
          borderRadius: 12,
          zIndex: 1050,
          padding: "20px 25px",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
          height: "auto",
          right: "auto",
          overflow: "inherit",
        }}
      >
        {/* Close Button */}
        <div className="d-flex justify-content-end align-items-center pt-0 pe-0">
          <button
            onClick={onCancel}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
              outline: "none",
            }}
            onFocus={(e) => e.target.blur()}
          >
            <svg width="18" height="18" viewBox="0 0 18 18">
              <path
                d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>

        {/* Title */}
        <h3
          style={{
            textAlign: "left",
            color: "#212529",
            fontSize: "20px",
            fontWeight: "600",
            lineHeight: "24px",
            fontFamily: "Montserrat",
            marginBottom: "10px",
            paddingTop: "20px",
          }}
        >
          {isManageOrder
            ? "Confirm to discard?"
            : entityName === "Cancel Campaign"
            ? "Confirm to cancel this Campaign?"
            : entityName === "End Campaign"
            ? "Confirm to end this Campaign in advance?"
            : entityName === "Campaign"
            ? "Confirm to discard this Campaign?"
            : entityName === "Deactivate Pricing Template"
            ? "Confirm to deactivate this Pricing Template?"
            : entityName === "Archive Pricing Template"
            ? "Confirm to archive this Pricing Template?"
            : entityName === "Pricing Template"
            ? "Confirm to discard this Pricing Template?"
            : entityName === "Platform Listing"
            ? "Confirm to discard this Listing?"
            : entityName === "Trade-In Listing"
            ? "Confirm to discard this Listing?"
            : entityName === "Trade-In Pricing"
            ? "Confirm to discard this Pricing?"
            : entityName === "Trade-In Listing Import"
            ? "Confirm to discard this Import?"
            : entityName === "Bulk Pricing"
            ? "Confirm to discard this Bulk Pricing?"
            : entityName === "Listing"
            ? "Confirm to discard"
            : entityName === "SKU Variation and its Options" ||
              entityName === "Variation Option"
            ? `Confirm to delete this ${entityName}`
            : entityName === "SPU and SKU"
            ? "Confirm to discard SPU & SKU"
            : "Confirm to discard " +
              (entityName === "SKU Variation" ||
              entityName === "Generation Rule"
                ? "the "
                : "this ") +
              (entityName === "SKU Abbreviation"
                ? "Abbreviation"
                : entityName === "Category"
                ? "Category Info"
                : entityName || "Record")}
        </h3>

        {/* Message */}
        {isManageOrder ? (
          <p
            style={{
              marginBottom: "0",
              textAlign: "left",
              color: "#6C757D",
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Montserrat",
              paddingBottom: "20px",
            }}
          >
            All unsaved changes will be lost
          </p>
        ) : entityName === "Cancel Campaign" ? (
          <p style={{ paddingBottom: "20px", fontFamily: "Montserrat", fontSize: "14px", fontWeight: 400, color: "#6C757D", lineHeight: "20px" }}>
            Once cancelled, this Promotional Campaign will be discarded and will not take effect as scheduled. This action cannot be undone.
          </p>
        ) : entityName === "End Campaign" ? (
          <p style={{ paddingBottom: "20px", fontFamily: "Montserrat", fontSize: "14px", fontWeight: 400, color: "#6C757D", lineHeight: "20px" }}>
            Once ended, this Promotional Campaign will stop immediately and be synced to downstream platforms. This action cannot be undone.
          </p>
        ) : entityName === "Campaign" ? (
          <p style={{ paddingBottom: "20px", fontFamily: "Montserrat", fontSize: "14px", fontWeight: 400, color: "#6C757D", lineHeight: "20px" }}>
            All unsaved changes will be lost.
          </p>
        ) : entityName === "SKU Variation" ||
          entityName === "Branch" ||
          entityName === "Generation Rule" ||
          entityName === "SKU Abbreviation" ||
          entityName === "SPU and SKU" ||
          entityName === "SKU Variation and it Options" ||
          entityName === "Variation Option" ? (
          <p style={{ paddingBottom: "20px",fontFamily: "Montserrat" }}>
            {entityName === "SKU Variation and it Options" ||
            entityName === "Variation Option"
              ? "SKUs generated by " +
                (entityName === "Variation Option"
                  ? "this Variation Option"
                  : "these Variation Options") +
                " will also be deleted at the same time. This action cannot be undone."
              : "All unsaved changes " +
                (entityName === "SPU and SKU" ? "in all steps " : "") +
                "will be lost."}
          </p>
        ) : (
              <p style={{
                paddingBottom: "20px",
                fontFamily: "Montserrat",
                fontSize: "14px",
                fontWeight: 400,
                color: "#6C757D",
                lineHeight: "20px",
                ...(entityName === "Trade-In Pricing" && {
                  lineHeight: "18px",
                }),
              }}>
            {entityName === "Deactivate Pricing Template"
              ? "After deactivation, this Pricing Template cannot be referenced when bulk editing Platform Price. You may reactivate it at any time."
              : entityName === "Archive Pricing Template"
              ? "Once archived, the Pricing Template can no longer be retrieved."
              : entityName === "SKU Variation and its Options"
              ? "SKUs generated by these Variation Options will also be deleted at the same time. This action cannot be undone."
              : entityName === "Platform Listing"
              ? "All unsaved changes in all steps will be lost."
              : entityName === "Trade-In Listing"
              ? "All unsaved changes in all steps will be lost."
              : entityName === "Trade-In Pricing"
              ? "All unsaved changes in all steps will be lost."
              : entityName === "Trade-In Listing Import"
              ? "All unsaved changes in all steps will be lost."
              : entityName === "Bulk Pricing" ||
                entityName === "Brand" ||
                entityName === "Category" ||
                entityName === "Listing" ||
                entityName === "Pricing Template"
              ? "All unsaved changes will be lost."
              : "This action cannot be undone."}
          </p>
        )}

        <div className="drawer-footer" style={{ paddingTop: "10px",paddingBottom:"10px" }}>
           <button
            onClick={onCancel}
            style={{
              display: "flex",
              height: "34px",
              minWidth: "100px",
              padding: "10px 0px",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              borderRadius: "8px",
              border: "1px solid  var(--navbar-dropdown-active, #212529)",
              background: "var(--Background-White, #FFF)",
              boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.10)",
              color: "var(--navbar-dropdown-active, #212529)",
              fontFamily: "Montserrat",
              fontSize: "12px",
              fontWeight: 600,
              fontStyle: "normal",
              lineHeight: "normal",
            }}
            onMouseDown={(e) => e.stopPropagation()}
          >

            Cancel
          </button>

          <button
            onClick={onConfirm}
            style={{
              display: "flex",
              height: "34px",
              minWidth: "100px",
              padding: "10px 0px",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              borderRadius: "8px",
              background: "var(--navbar-dropdown-active, #212529)",
              boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.10)",
              color: "var(--Background-White, #FFF)",
              fontFamily: "Montserrat",
              fontSize: "12px",
              fontWeight: 600,
              fontStyle: "normal",
              lineHeight: "normal",
            }}
            onMouseDown={(e) => e.stopPropagation()}
          >
            {isManageOrder ? "Discard" : "Confirm"}
          </button>
        </div>
      </div>
    </>
  );
}; 

export default DiscardConfirmationModal;